import AT from '../actionTypes/'

export function setTeamRoles(teamRoles) {
  return { type: AT.SET_TEAM_ROLES, payload: teamRoles }
}
